/* Ability Warehouse — product page extras: "Product fact sheet" download buttons (PDF / Word) and the product video.
   Data comes from #aw-fs-data (printed by layout/theme.liquid on product pages).
   - Fact sheet: two buttons under the buy card links; the generator (aw-factsheet.js) and its libraries load only on tap.
   - Video: when the product has a YouTube video (metafield custom.youtube_id), a "See it in action" panel is added at the top of the
     specifications. It shows the thumbnail first and only loads YouTube (privacy-enhanced, youtube-nocookie) when played,
     so the page stays fast. */
(function () {
  'use strict';
  var el = document.getElementById('aw-fs-data');
  if (!el) return;
  var d; try { d = JSON.parse(el.textContent); } catch (e) { return; }

  /* ---------- fact sheet buttons ---------- */
  var ICON = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M12 4v11m0 0-4.5-4.5M12 15l4.5-4.5M5 19h14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var box = document.createElement('div');
  box.className = 'awfs';
  box.innerHTML = '<span class="awfs__l">Product fact sheet</span>' +
    '<button type="button" class="awfs__b" data-awfs="pdf">' + ICON + 'PDF</button>' +
    '<button type="button" class="awfs__b" data-awfs="word">' + ICON + 'Word</button>' +
    '<span class="awfs__s" role="status" aria-live="polite"></span>';
  var anchor = document.querySelector('.pdp-links') || document.querySelector('.pdp-form');
  if (anchor) anchor.parentNode.insertBefore(box, anchor.nextSibling);
  var status = box.querySelector('.awfs__s');
  var gen = null;
  function loadGen() {
    if (gen) return gen;
    return (gen = new Promise(function (res, rej) {
      var s = document.createElement('script'); s.src = d.factsheet_js; s.async = true;
      s.onload = function () { res(window.AWFactSheet); }; s.onerror = function () { gen = null; rej(); };
      document.head.appendChild(s);
    }));
  }
  box.addEventListener('click', function (e) {
    var b = e.target.closest('[data-awfs]'); if (!b || b.disabled) return;
    var kind = b.dataset.awfs, label = b.innerHTML;
    box.querySelectorAll('[data-awfs]').forEach(function (x) { x.disabled = true; });
    b.innerHTML = '<span class="awfs__spin" aria-hidden="true"></span>Preparing…';
    status.textContent = '';
    loadGen().then(function (G) { return kind === 'pdf' ? G.pdf() : G.word(); })
      .then(function () { status.textContent = 'Downloaded'; })
      .catch(function () { status.textContent = 'Sorry, that didn’t work. Please try again.'; })
      .then(function () { b.innerHTML = label; box.querySelectorAll('[data-awfs]').forEach(function (x) { x.disabled = false; }); setTimeout(function () { status.textContent = ''; }, 4000); });
  });
  /* warm the generator when the pointer heads for the buttons */
  box.addEventListener('pointerenter', function () { loadGen().catch(function () {}); }, { once: true });

  /* ---------- product video ---------- */
  if (d.youtube && /^[\w-]{11}$/.test(d.youtube)) {
    var sec = document.createElement('div');
    sec.className = 'awv';
    sec.id = 'pdp-video';
    sec.innerHTML = '<h2 class="pdp-h2">See it in action</h2>' +
      '<div class="awv__frame"><button type="button" class="awv__play" aria-label="Play video: ' + esc(d.youtube_title || d.title) + '">' +
      '<img src="https://i.ytimg.com/vi/' + d.youtube + '/hqdefault.jpg" alt="" loading="lazy" width="480" height="360">' +
      '<span class="awv__btn" aria-hidden="true"><svg viewBox="0 0 68 48" width="68" height="48"><path d="M66.5 7.7a8.5 8.5 0 0 0-6-6C55.2.3 34 .3 34 .3S12.8.3 7.5 1.7a8.5 8.5 0 0 0-6 6C.1 13 .1 24 .1 24s0 11 1.4 16.3a8.5 8.5 0 0 0 6 6C12.8 47.7 34 47.7 34 47.7s21.2 0 26.5-1.4a8.5 8.5 0 0 0 6-6C67.9 35 67.9 24 67.9 24s0-11-1.4-16.3z" fill="#D7141E"/><path d="M45 24 27 14v20z" fill="#fff"/></svg></span>' +
      '</button></div>' + (d.youtube_title ? '<p class="awv__cap">' + esc(d.youtube_title) + '</p>' : '');
    var after = document.getElementById('pdp-specs');
    /* inside the specifications block, at the top: it then takes that block's full width and grid row */
    if (after) after.insertBefore(sec, after.firstChild);
    sec.querySelector('.awv__play').addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + d.youtube + '?autoplay=1&rel=0&modestbranding=1';
      f.title = d.youtube_title || d.title; f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'; f.allowFullscreen = true;
      this.replaceWith(f);
    });
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var css = document.createElement('style');
  css.textContent =
    '.awfs{display:flex;flex-wrap:wrap;align-items:center;gap:8px;margin-top:14px;padding-top:14px;border-top:1px solid var(--line,#E3E7EC)}' +
    '.awfs__l{font:700 13px Inter,sans-serif;color:var(--ink,#1E2A4A);margin-right:4px}' +
    '.awfs__b{display:inline-flex;align-items:center;gap:6px;height:36px;padding:0 14px;border:1.5px solid var(--navy,#0E2A47);border-radius:999px;background:#fff;color:var(--navy,#0E2A47);font:700 13px Inter,sans-serif;cursor:pointer;transition:background .15s,color .15s}' +
    '.awfs__b:hover{background:var(--navy,#0E2A47);color:#fff}' +
    '.awfs__b[disabled]{opacity:.65;cursor:progress}' +
    '.awfs__s{font-size:12.5px;color:var(--muted,#5B6478)}' +
    '.awfs__spin{width:12px;height:12px;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:awfsSpin .7s linear infinite}' +
    '@keyframes awfsSpin{to{transform:rotate(360deg)}}' +
    '.awv{margin:0 0 36px}' +
    '.awv__frame{position:relative;aspect-ratio:16/9;max-width:860px;border-radius:16px;overflow:hidden;background:#0E2A47;box-shadow:0 18px 40px -26px rgba(14,42,71,.55)}' +
    '.awv__frame iframe,.awv__play{position:absolute;inset:0;width:100%;height:100%;border:0}' +
    '.awv__play{padding:0;cursor:pointer;background:#000}' +
    '.awv__play img{width:100%;height:100%;object-fit:cover;opacity:.92;transition:opacity .2s}' +
    '.awv__play:hover img{opacity:1}' +
    '.awv__btn{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);transition:transform .15s}' +
    '.awv__play:hover .awv__btn{transform:translate(-50%,-50%) scale(1.08)}' +
    '.awv__play:focus-visible{outline:3px solid #FFD500;outline-offset:-3px}' +
    '.awv__cap{margin:10px 0 0;font-size:13.5px;color:var(--muted,#5B6478)}';
  document.head.appendChild(css);
})();
